import React from "react";

import ConstructionBanner from "../../modules/toastBar/toastBar";
import * as styles from './styles.module.scss';

import BackToTopButton from "src/modules/backToTopButton/back.to.top.button";

const EmptyLayout = ({ children, pageContext, language }) => {
  // add topbar to layout
  let Topbar = () => null
  if (pageContext.layout?.toastbar?.id) {
    Topbar = () => <ConstructionBanner data={{ selectedLanguage: language, item: pageContext.layout.toastbar }} />;
  }

  return (
    <>
      <div className={styles.mainContent}>
        <Topbar />
        {children}
        <BackToTopButton button={pageContext.layout?.back_to_top_button}/>
      </div>
    </>
  );
}

export default EmptyLayout;
